// extracted by mini-css-extract-plugin
export default {"center_area":"CenterArea_center_area__GGDxK"};